<template>
  <div class="classManage">
    <div class="relative">
      <div class="line">
        <el-input
          class="search-input"
          v-model="searchClassNo"
          placeholder="输入班级编号"
          clearable
        ></el-input>
        <el-select
          v-if="role == 1"
          class="search-select"
          v-model="searchSchool"
          placeholder="所属学校"
          clearable
        >
          <el-option v-for="item in schoolList" :label="item.nick_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
      </div>
      <el-button
        v-if="role == 2"
        class="search-button"
        style="position: absolute; right: 10px; top: 20px"
        type="primary"
        @click="toAdd()"
        >新建班级</el-button
      >
    </div>
    <el-table class="data-table" :data="classData" v-loading="loading">
      <el-table-column align="center" prop="id" label="ID"></el-table-column>
      <el-table-column align="center" label="班级编号/班级名称">
        <template slot-scope="scope">
          <div>{{ scope.row.no }}</div>
          <div>{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="年级">
        <template slot-scope="scope">{{gradeName[scope.row.grade_id]}}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="school_name"
        label="学校"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="student_count"
        label="学生数量"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="teacher_count"
        label="老师数量"
      ></el-table-column>
      <el-table-column align="center" label="操作" width="250">
        <template slot-scope="scope">
          <div style="margin-bottom: 5px">
            <el-button type="primary" size="mini" @click="toStudent(scope.row)"
              >学生列表</el-button
            >
            <el-button type="primary" size="mini" @click="toTeacher(scope.row)"
              >老师列表</el-button
            >
          </div>
          <div v-if="role == 2">
            <el-button type="primary" size="mini" @click="toEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="mini" @click="delOne(scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="onPageChange"
      :current-page="page"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <!-- 新建编辑班级 -->
    <el-dialog
      :title="isAdd ? '新建班级' : '编辑班级'"
      :visible.sync="addVisible"
      width="40%"
    >
      <el-row :gutter="10" class="detail-row">
        <el-col :span="6" style="text-align: center">学校名称：</el-col>
        <el-col :span="16" class="text-left">
          {{ school_name }}
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="6" style="text-align: center">选择年级：</el-col>
        <el-col :span="16" class="text-left">
          <el-select
            class="search-select"
            v-model="addInfo.grade"
            placeholder="选择年级"
            clearable
          >
            <el-option
              v-for="item in grades"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="6" style="text-align: center">班级名称：</el-col>
        <el-col :span="16" class="text-left">
          <el-input v-model="addInfo.name" placeholder=""></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" @click="onClassConfirm">保存</el-button>
      </span>
    </el-dialog>
    <!-- 学生列表 -->
    <el-dialog title="学生列表" :visible.sync="studentVisible" width="60%">
      <!-- <div class="line">
        <el-input
          class="search-input"
          v-model="studentSearchUid"
          placeholder="输入用户ID"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="studentSearchName"
          placeholder="输入用户昵称"
          clearable
        ></el-input>
        <el-button class="search-button" type="primary" @click="searchStudent()"
          >查询</el-button
        >
      </div> -->
      <el-table class="data-table" :data="studentList" v-loading="loading">
        <el-table-column align="center" prop="id" label="ID"></el-table-column>
        <el-table-column align="center" label="学生信息">
          <template slot-scope="scope">
            <div class="flex">
              <img class="avatar" src="" alt="" />
              <div style="width: 100%">
                <div class="userInfo">{{ scope.row.nick_name }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="toStudentDetail(scope.row.id)">学生详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onStudentPageChange"
        :current-page="pageStudent"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="totalStudent"
      >
      </el-pagination>
    </el-dialog>
    <!-- 老师列表 -->
    <el-dialog title="老师列表" :visible.sync="teacherVisible" width="60%">
      <el-table class="data-table" :data="teacherList" v-loading="loading">
        <el-table-column align="center" prop="id" label="ID"></el-table-column>
        <el-table-column align="center" label="老师信息">
          <template slot-scope="scope">
            <div class="flex">
              <img class="avatar" src="" alt="" />
              <div style="width: 100%">
                <div class="userInfo">{{ scope.row.nick_name }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button v-if="role == 2" type="primary" size="mini" @click="unbind(scope.row)">解除绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onTeacherPageChange"
        :current-page="pageTeacher"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="totalTeacher"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassList,
  getSchoolList,
  saveClass,
  delClass,
  getStudentInClass,
  getTeacherInClass,
  unbindTeacher
} from "@/api/api.js";
import { getGradesList } from '@/utils/common'
export default {
  name: "ClassManage",
  data: () => ({
    role: 0, // 1-超管 2-学校管理
    searchClassNo: "",
    searchSchool: "",
    classData: [],
    grades: [],
    schoolList: [],
    gradeName: {},
    loading: false,
    page: 1,
    total: 0,
    school_name: "",
    // 新建班级的数据
    addInfo: {
      grade: "",
      name: "",
    },
    addVisible: false,
    isAdd: true,
    // 学生列表
    studentSearchUid: "",
    studentSearchName: "",
    studentList: [],
    pageStudent: 1,
    totalStudent: 0,
    studentVisible: false,
    // 老师列表
    teacherList: [],
    pageTeacher: 1,
    totalTeacher: 0,
    teacherVisible: false,
    classId: 0
  }),
  async mounted() {
    let user = JSON.parse(localStorage.getItem("mykc-user"));
    this.school_name = user.nick_name
    if (!user.role) {
      this.role = 1;
      getSchoolList().then((res) => {
        this.schoolList = res.data.data
      });
    } else {
      this.role = 2;
    }
    this.search();
    // 获取年级列表
    this.grades = await getGradesList()
    this.grades.forEach(item => {
        this.gradeName[item.id] = item.name
      })
  },
  methods: {
    onPageChange(e) {
      this.page = e
      this.search()
    },
    onStudentPageChange(e) {
      this.pageStudent = e
      this.studentSearch()
    },
    onTeacherPageChange(e) {
      this.pageTeacher = e
      this.teacherSearch()
    },
    search() {
      let params = { page: this.page };
      if (this.searchClassNo) {
        params.no = this.searchClassNo;
      }
      if (this.searchSchool) {
        params.school_id = this.searchSchool;
      }
      getClassList(params).then((res) => {
        this.classData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    toAdd() {
      this.isAdd = true;
      this.addVisible = true;
    },
    toEdit(row) {
      this.isAdd = false;
      this.addVisible = true;
      this.addInfo.id = row.id;
      this.addInfo.name = row.name
      this.addInfo.grade = row.grade_id
    },
    toStudent(row) {
      this.studentVisible = true;
      this.classId = row.id
      this.studentSearch()
    },
    toStudentDetail(id) {
      this.$router.push(`/userManage?id=${id}`)
    },
    studentSearch(){
      getStudentInClass(this.pageStudent, this.classId).then(res => {
        this.studentList = res.data.data.list
        this.totalStudent = res.data.data.total
      })
    },
    teacherSearch() {
      getTeacherInClass(this.pageTeacher, this.classId).then(res => {
        this.teacherList = res.data.data.list
        this.totalTeacher = res.data.data.total
      })
    },
    toTeacher(row) {
      this.teacherVisible = true;
      this.classId = row.id
      this.teacherSearch()
    },
    delOne(row) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delClass(row.id).then(res => {
          if (res.data.code == 0) {
              this.$message({
                message: `删除成功！`,
                type: "success",
              });
              this.search();
            }
        })
      });
    },
    onClassConfirm() {
      if (!this.addInfo.grade) {
        this.$message({
          message: "请选择年级！",
          type: "warning",
        });
        return;
      }
      if (!this.addInfo.name) {
        this.$message({
          message: "请输入班级名称！",
          type: "warning",
        });
        return;
      }
      let params = { name: this.addInfo.name, grade_id: this.addInfo.grade };
      if (!this.isAdd) {
        params.id = this.addInfo.id;
      }
      saveClass(params).then((res) => {
        this.$message({
          message: `${this.isAdd ? "新增" : "修改"}成功！`,
          type: "success",
        });
        this.addVisible = false;
        this.search();
      });
    },
    unbind(row) {
      this.$confirm("确认解绑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        unbindTeacher(this.classId, row.id).then(res => {
          if (res.data.code == 0) {
              this.$message({
                message: `解绑成功！`,
                type: "success",
              });
              this.teacherSearch();
            }
        })
      })
    },
  },
};
</script>

<style lang="less">
.classManage {
  .relative {
    position: relative;
  }

  .detail-row {
    line-height: 40px;
    margin-bottom: 20px;
  }

  .flex {
    display: flex;
  }
}
</style>